import { createSelector } from '@reduxjs/toolkit';
import { TState } from 'store/types';

export const getGameRps = (state: TState) => state.games || {};

export const getUserBalance = createSelector(
  getGameRps,
  ({ appState: { data } }) => data?.user_balance || '0',
);

export const getActiveGame = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) => currentGame.rock_scissors_paper,
);

export const getActiveGameStatus = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) => currentGame.rock_scissors_paper?.status,
);

export const getActiveGameAwaitingTimer = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) =>
    currentGame.rock_scissors_paper?.awaiting_players_timer,
);

export const getActiveGameLoading = createSelector(
  getGameRps,
  ({ activeGame: { loading } }) => loading,
);

export const getActiveGameMoveLoading = createSelector(
  getGameRps,
  ({ activeGame: { moveLoading } }) => moveLoading,
);

export const getActiveGameError = createSelector(
  getGameRps,
  ({ activeGame: { error } }) => error,
);

export const getIsOpponents = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) =>
    !!currentGame.rock_scissors_paper?.players?.opponents?.length,
);

export const getIsActiveGame = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) => !!currentGame.rock_scissors_paper?.id,
);

export const getCurrentActiveRaundGame = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) =>
    currentGame.rock_scissors_paper?.rounds?.current?.round,
);

export const getCurrentActiveRaundStatus = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) =>
    currentGame.rock_scissors_paper?.rounds?.current?.status?.id,
);

export const getisNoCompleteCurrentActiveGameStatus = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) =>
    currentGame.rock_scissors_paper?.rounds?.current?.status?.id !==
    'completed',
);

export const getMoveOpponent = createSelector(
  getGameRps,
  ({ activeGame: { currentGame } }) =>
    currentGame.rock_scissors_paper?.rounds?.current?.actions?.opponent
      ?.move_made,
);

export const getAppStateCurrentGames = createSelector(
  getGameRps,
  ({ appState: { data } }) => data?.current_games,
);

export const getAppStateCurrentGameError = createSelector(
  getGameRps,
  ({ appState: { error } }) => error,
);

export const getGamesRatingData = createSelector(
  getGameRps,
  ({ rating: { rock_scissors_paper, loading, error } }) => ({
    data: {
      ...rock_scissors_paper,
      all: Object.values(rock_scissors_paper?.all || {}),
    },
    loading,
    error,
  }),
);

export const getGamesFriendsData = createSelector(
  getGameRps,
  ({ friends: { rock_scissors_paper, loading, error } }) => ({
    data: Object.values(rock_scissors_paper || {}),
    loading,
    error,
  }),
);

export const getCurrentMove = createSelector(
  getGameRps,
  ({
    activeGame: {
      currentGame: { rock_scissors_paper },
    },
  }) => rock_scissors_paper?.rounds.current.actions.current.move_made || false,
);

export const getOpponentMove = createSelector(
  getGameRps,
  ({
    activeGame: {
      currentGame: { rock_scissors_paper },
    },
  }) => rock_scissors_paper?.rounds.current.actions.opponent.move_made || false,
);

export const getisAllMove = createSelector(
  getGameRps,
  ({
    activeGame: {
      currentGame: { rock_scissors_paper },
    },
  }) =>
    rock_scissors_paper?.rounds.current.actions.opponent.move_made &&
    rock_scissors_paper?.rounds.current.actions.current.move_made,
);

export const getCurrentMoveTimer = createSelector(
  getGameRps,
  ({
    activeGame: {
      currentGame: { rock_scissors_paper },
    },
  }) => rock_scissors_paper?.rounds.current.make_move_timer || undefined,
);

export const getCurrentActions = createSelector(
  getGameRps,
  ({
    activeGame: {
      currentGame: { rock_scissors_paper },
    },
  }) => rock_scissors_paper?.rounds.current.actions.current.action,
);

export const getActiveGameId = createSelector(
  getGameRps,
  ({
    activeGame: {
      currentGame: { rock_scissors_paper },
    },
  }) => rock_scissors_paper?.id,
);

export const getActiveGameIsRandom = createSelector(
  getGameRps,
  ({ random: { isRandom } }) => isRandom,
);

export const getActiveGamelockRandom = createSelector(
  getGameRps,
  ({ random: { lockRandom } }) => lockRandom,
);

export const getActiveGameStopMove = createSelector(
  getGameRps,
  ({ random: { stopMove } }) => stopMove,
);
